<div class="stream-tab-container">
  <div class="header-text">
    <div class="stream-name">
      <a
        [matTooltip]="getMaxStreamTooltip()"
        (click)="addStream()"
        class="add-stream"
        [ngClass]="isValidCloneAction ? 'add-stream-disable' : 'add-stream'"
        ><i class="mdi mdi-plus-thick"></i> Add stream</a
      >
    </div>
    <div class="error-msg">
      <div class="bandwidth-error" *ngIf="vlidateMaxLoad()">
        Overall bandwidth too high for source device
      </div>
      <div class="bandwidth-error" *ngIf="streamRows?.[0]?.streamMaxServices === 1">
        Choose the source device from endpoints.
      </div>
    </div>
    <div class="bandwidth">
      <div class="bandwidth-label">
        Overall Bandwidth:
        <div [ngClass]="vlidateMaxLoad() ? 'bandwidth-error' : 'bandwidth-success'">
          {{ calculateTotalMaxBandWidth() }}
        </div>
      </div>
    </div>
  </div>
  <div class="mat-elevation-z8">
    <mat-table #table [dataSource]="dataSource" multiTemplateDataRows="true" class="table">
      <ng-container matColumnDef="streamName">
        <mat-header-cell *matHeaderCellDef class="header-label"> Name </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex" class="name-cell">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="text"
              name="streamName"
              class="width-115"
              [(ngModel)]="element.streamName"
              [ngClass]="{ 'error-msg': checkValidation('name', element.streamName)?.isValid }"
              (ngModelChange)="
                checkValidation('name', element.streamName, element);
                onDataChange(element.streamName, i, configMapping.STREAM_NAME, element)
              "
              [matTooltip]="checkValidation('name', element.streamName)?.message"
            />
          </div>
          <div class="advanced-settings second-row">
            <a (click)="expandCollapse(element)"
              >Advanced settings
              <span>
                <i
                  [ngClass]="element.isExpanded ? enabledIcon : disabledIcon"
                  (click)="onSelectSptFrame(frame.enable, sptFrameIndex)"
                >
                </i></span
            ></a>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamDscp">
        <mat-header-cell *matHeaderCellDef class="header-label"> DSCP </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex" class="dscp-cell">
          <div class="width-115 first-row">
            <mat-select
              class="option-list"
              #txInterfaceInput="ngModel"
              [(ngModel)]="element.streamDscp"
              [ngClass]="{
                'error-msg': checkValidation('dscp', element.streamDscp)?.isValid && !ipV6Type
              }"
              name="streamDscp"
              (selectionChange)="
                ipV6Type
                  ? onDataChange(element.streamDscp, i, configMapping.TOS, element)
                  : checkValidation('dscp', element.streamDscp, element);
                onDataChange(element.streamDscp, i, configMapping.TOS, element)
              "
              [matTooltip]="
                ipV6Type
                  ? 'DSCP not applicable for IPV6'
                  : checkValidation('dscp', element.streamDscp)?.message
              "
              [disabled]="ipV6Type"
            >
              <mat-option *ngFor="let dscp of dscpConfigTypes" [value]="dscp.id">
                {{ dscp.value }}
                ({{ dscp.id }})</mat-option
              >
            </mat-select>
          </div>
          <div class="vlan-fields second-row">
            <div class="width-60" *ngIf="vlanConfig === 'tagged' || vlanConfig === 'q_in_q'">
              <div class="label">S-VLAN Priority</div>
              <mat-select
                class="option-list width-60"
                #txInterfaceInput="ngModel"
                [(ngModel)]="element.stream_svlanPriority"
                name="streamDscp"
                [ngClass]="{
                  'error-msg': checkValidation('svlan', element.stream_svlanPriority, element)
                    ?.isValid
                }"
                (selectionChange)="
                  checkValidation('svlan', element.stream_svlanPriority, element);
                  onDataChange(
                    element.stream_svlanPriority,
                    i,
                    configMapping.SVLAN_PRIORITY,
                    element
                  )
                "
                [matTooltip]="
                  checkValidation('svlan', element.stream_svlanPriority, element)?.message
                "
              >
                <mat-option *ngFor="let svlan of svlanPriorityTypes" [value]="svlan.id">
                  {{ svlan.value }}</mat-option
                >
              </mat-select>
            </div>
            <div class="width-60 c-valn-priority" *ngIf="vlanConfig === 'q_in_q'">
              <div class="label">C-VLAN Priority</div>
              <mat-select
                class="option-list width-60"
                #txInterfaceInput="ngModel"
                [ngClass]="{
                  'error-msg': checkValidation('cvlan', element.stream_cvlanPriority, element)
                    ?.isValid
                }"
                [(ngModel)]="element.stream_cvlanPriority"
                name="streamDscp"
                (selectionChange)="
                  checkValidation('cvlan', element.stream_cvlanPriority, element);
                  onDataChange(
                    element.stream_cvlanPriority,
                    i,
                    configMapping.CVLAN_PRIORITY,
                    element
                  )
                "
                [matTooltip]="
                  checkValidation('cvlan', element.stream_cvlanPriority, element)?.message
                "
              >
                <mat-option *ngFor="let cvlan of cvlanPriorityTypes" [value]="cvlan.id">
                  {{ cvlan.value }}</mat-option
                >
              </mat-select>
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamDirectional">
        <mat-header-cell *matHeaderCellDef class="header-label"> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div *ngIf="testMode.indexOf('bidirectional') !== -1">
            <label class="width-50 directional-arrows first-row"
              >A <span class="directional-arrows-greater-than"> > </span> B</label
            >
            <div class="bi-directional second-row">
              <label class="width-50 directional-arrows"
                >A <span class="directional-arrows-less-than"> < </span> B</label
              >
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="streamCir">
        <mat-header-cell *matHeaderCellDef class="header-label">
          CIR
          <div class="sub-label">Mbps</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 8)"
              (blur)="onBlurDecimalCleanup(element, 'streamCir')"
              name="streamCir"
              class="width-50"
              [(ngModel)]="element.streamCir"
              [ngClass]="{ 'error-msg': checkValidation('cir', element.streamCir)?.isValid }"
              (ngModelChange)="
                checkValidation('cir', element.streamCir, element);
                onDataChange(element.streamCir, i, configMapping.CIR, element);
                calculateMaxLoad(element)
              "
              [matTooltip]="checkValidation('cir', element.streamCir)?.message"
            />
          </div>

          <div class="second-row" *ngIf="testMode.indexOf('bidirectional') !== -1">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 8)"
              (blur)="onBlurDecimalCleanup(element, 'streamCir2')"
              name="streamCir2"
              class="width-50"
              [(ngModel)]="element.streamCir2"
              [ngClass]="{ 'error-msg': checkValidation('cir', element.streamCir2)?.isValid }"
              (ngModelChange)="
                checkValidation('cir', element.streamCir2, element);
                onDataChange(element.streamCir2, i, configMapping.CIR2, element)
              "
              [matTooltip]="checkValidation('cir', element.streamCir2)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="streamEir">
        <mat-header-cell *matHeaderCellDef class="header-label">
          EIR
          <div class="sub-label">Mbps</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 8)"
              (blur)="onBlurDecimalCleanup(element, 'streamEir')"
              name="streamEir"
              class="width-50"
              [(ngModel)]="element.streamEir"
              [ngClass]="{ 'error-msg': checkValidation('eir', element.streamEir)?.isValid }"
              (ngModelChange)="
                checkValidation('eir', element.streamEir, element);
                onDataChange(element.streamEir, i, configMapping.EIR, element);
                calculateMaxLoad(element)
              "
              [matTooltip]="checkValidation('eir', element.streamEir)?.message"
            />
          </div>

          <div class="second-row" *ngIf="testMode.indexOf('bidirectional') !== -1">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 8)"
              (blur)="onBlurDecimalCleanup(element, 'streamEir2')"
              name="streamEir2"
              class="width-50"
              [(ngModel)]="element.streamEir2"
              [ngClass]="{ 'error-msg': checkValidation('eir', element.streamEir2)?.isValid }"
              (ngModelChange)="
                checkValidation('eir', element.streamEir2, element);
                onDataChange(element.streamEir2, i, configMapping.EIR2, element)
              "
              [matTooltip]="checkValidation('eir', element.streamEir2)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamPolicing">
        <mat-header-cell *matHeaderCellDef class="header-label">
          Policing
          <div class="sub-label">Mbps allowed</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="policing-cell first-row">
            <mat-slide-toggle
              name="isEnabledPolicing"
              class="enable-row"
              color="primary"
              [(ngModel)]="element.isEnabledPolicing"
              (ngModelChange)="
                calculateMaxLoad(element);
                onDataChange(element.isEnabledPolicing, i, configMapping.POLICING, element)
              "
            >
            </mat-slide-toggle
            ><input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 7)"
              (blur)="onBlurDecimalCleanup(element, 'streamPolicing')"
              name="streamPolicing"
              class="width-40"
              [(ngModel)]="element.streamPolicing"
              [disabled]="!element.isEnabledPolicing"
              [ngClass]="{
                'error-msg': checkValidation('policing', element.streamPolicing, element)?.isValid
              }"
              (ngModelChange)="
                checkValidation('policing', element.streamPolicing, element);
                onDataChange(element.streamPolicing, i, configMapping.MAX_IR, element)
              "
              [matTooltip]="checkValidation('policing', element.streamPolicing, element)?.message"
            />
          </div>
          <div class="policing-cell second-row" *ngIf="testMode.indexOf('bidirectional') !== -1">
            <mat-slide-toggle
              name="isEnabledPolicing2"
              class="enable-row"
              color="primary"
              [(ngModel)]="element.isEnabledPolicing2"
              (ngModelChange)="
                calculateMaxLoad(element);
                onDataChange(element.isEnabledPolicing2, i, configMapping.POLICING2, element)
              "
            >
            </mat-slide-toggle
            ><input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 7)"
              (blur)="onBlurDecimalCleanup(element, 'streamPolicing2')"
              name="streamPolicing2"
              class="width-40"
              [(ngModel)]="element.streamPolicing2"
              [disabled]="!element.isEnabledPolicing2"
              [ngClass]="{
                'error-msg': checkValidation('policing', element.streamPolicing2, element)?.isValid
              }"
              (ngModelChange)="
                checkValidation('policing', element.streamPolicing2, element);
                onDataChange(element.streamPolicing2, i, configMapping.MAX_IR2, element)
              "
              [matTooltip]="checkValidation('policing', element.streamPolicing2, element)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamLoss">
        <mat-header-cell *matHeaderCellDef class="header-label">
          Loss
          <div class="sub-label">(%)</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 7)"
              (blur)="onBlurDecimalCleanup(element, 'streamLoss')"
              name="streamLoss"
              class="width-40"
              [(ngModel)]="element.streamLoss"
              [ngClass]="{ 'error-msg': checkValidation('loss', element.streamLoss)?.isValid }"
              (ngModelChange)="
                checkValidation('loss', element.streamLoss, element);
                onDataChange(element.streamLoss, i, configMapping.LOSS, element)
              "
              [matTooltip]="checkValidation('loss', element.streamLoss)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamFD">
        <mat-header-cell *matHeaderCellDef class="header-label">
          FD
          <div class="sub-label">(ms)</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <mat-slide-toggle
              *ngIf="showFDToggle()"
              name="isToggledFD"
              class="enable-row"
              color="primary"
              [(ngModel)]="element.isToggledFD"
              (ngModelChange)="onFDToggleChange(element.isToggledFD, i)"
            >
            </mat-slide-toggle>
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 7)"
              (blur)="onBlurDecimalCleanup(element, 'streamFD')"
              name="streamFD"
              class="width-40"
              [disabled]="!element.isToggledFD"
              [(ngModel)]="element.streamFD"
              [ngClass]="{ 'error-msg': checkValidation('fd', element.streamFD)?.isValid }"
              (ngModelChange)="
                checkValidation('fd', element.streamFD, element);
                onDataChange(element.streamFD, i, configMapping.FD, element)
              "
              [matTooltip]="checkValidation('fd', element.streamFD)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamFDV">
        <mat-header-cell *matHeaderCellDef class="header-label">
          FDV
          <div class="sub-label">(ms)</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="first-row">
            <input
              matInput
              autocomplete="off"
              type="number"
              (input)="enforceMaxLength($event, 7)"
              (blur)="onBlurDecimalCleanup(element, 'streamFDV')"
              name="streamFDV"
              class="width-40"
              [(ngModel)]="element.streamFDV"
              [ngClass]="{ 'error-msg': checkValidation('fdv', element.streamFDV)?.isValid }"
              (ngModelChange)="
                checkValidation('fdv', element.streamFDV, element);
                onDataChange(element.streamFDV, i, configMapping.FDV, element)
              "
              [matTooltip]="checkValidation('fdv', element.streamFDV)?.message"
            />
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamFrame">
        <mat-header-cell *matHeaderCellDef class="header-label">
          Frame
          <div class="sub-label">Size(s)</div></mat-header-cell
        >
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="frames width-120 first-row">
            <table>
              <ng-container *ngIf="isConfigTestEnable">
                <tr *ngIf="element.isMultiSelectEnable">
                  <th class="label">SCT:</th>
                  <td class="label-value">
                    <mat-label matTooltip="{{ element.streamSctFrame }}">{{
                      element.sctFrameDisplay
                    }}</mat-label>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="isPerformanceTestEnable">
                <tr *ngIf="element.isMultiSelectEnable">
                  <th class="label">SPT:</th>
                  <td class="label-value">
                    <mat-label matTooltip="{{ element.streamSptFrame }}">{{
                      element.sptFrameDisplay
                    }}</mat-label>
                  </td>
                </tr>
              </ng-container>
              <tr *ngIf="!element.isMultiSelectEnable">
                <td class="label-value">
                  <mat-label matTooltip="{{ element.streamSptFrame }}">{{
                    element.sptFrameDisplay
                  }}</mat-label>
                </td>
              </tr>
            </table>
            <a class="edit" (click)="onClickFrameSize(element, i)">edit</a>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamMaxBw" class="width-58">
        <mat-header-cell *matHeaderCellDef class="header-label"> Max BW </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <label>{{ element.streamMxBw }}</label>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="streamAction">
        <mat-header-cell *matHeaderCellDef class="header-label"> Actions </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <button
            mat-button
            [matMenuTriggerFor]="menu"
            (click)="
              checkValidation('actionDisable', element.strmInUse, element);
              checkRemoveActionValid(element)
            "
          >
            <i class="icon mdi mdi-dots-horizontal"></i>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item [disabled]="isValidCloneAction" (click)="cloneStream(element)">
              <i class="mdi mdi-content-copy"></i><span>Clone</span>
            </button>
            <button
              mat-menu-item
              [disabled]="isValidRemove || isValidRemoveAction"
              (click)="removeStream(element)"
            >
              <i class="mdi mdi-delete"></i><span>Remove</span>
            </button>
            <button
              *ngIf="!element.strmInUse"
              mat-menu-item
              (click)="enableOrDisableStream(element, i)"
            >
              <i class="mdi mdi-power"></i><span>Enable</span>
            </button>
            <button
              *ngIf="element.strmInUse"
              mat-menu-item
              [disabled]="!errorValidationObj.isValidDisableStream || isValidRemoveAction"
              (click)="enableOrDisableStream(element, i)"
            >
              <i class="mdi mdi-power"></i><span>Disable</span>
            </button>
          </mat-menu>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="expand-fields">
            <div class="cbs-fields-group" *ngIf="showFormField(configMapping.CBS)">
              <div class="expand-fields-alignment">
                <div class="label">CBS (KB)</div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  name="streamCbs"
                  class="width-50"
                  [(ngModel)]="element.streamCbs"
                  [ngClass]="{ 'error-msg': checkValidation('cbs', element.streamCbs)?.isValid }"
                  (ngModelChange)="
                    checkValidation('cbs', element.streamCbs, element);
                    onDataChange(element.streamCbs, i, configMapping.CBS, element);
                    calculateMaxLoad(element)
                  "
                  [matTooltip]="checkValidation('cbs', element.streamCbs)?.message"
                />
              </div>
              <div class="expand-fields-alignment" *ngIf="showFormField(configMapping.KB_SIZE)">
                <div class="label">KB size</div>
                <mat-select
                  class="option-list width-70"
                  #txInterfaceInput="ngModel"
                  [(ngModel)]="element.streamKbSize"
                  name="streamKbSize"
                  [disabled]="element.streamCbs <= 0"
                  (selectionChange)="
                    onDataChange(element.streamKbSize, i, configMapping.KB_SIZE, element)
                  "
                >
                  <mat-option *ngFor="let kbSize of kbSizeTypes" [value]="kbSize.value">
                    {{ kbSize.name }}</mat-option
                  >
                </mat-select>
              </div>
              <div
                class="expand-fields-alignment"
                *ngIf="showFormField(configMapping.CBS_REPETITIONS)"
              >
                <div class="label">Repetitions</div>
                <input
                  matInput
                  autocomplete="off"
                  type="number"
                  name="streamRepetitions"
                  class="width-50"
                  [(ngModel)]="element.streamRepetitions"
                  [disabled]="element.streamCbs <= 0"
                  [ngClass]="{
                    'error-msg': checkValidation('repetitions', element.streamRepetitions)?.isValid
                  }"
                  (ngModelChange)="
                    checkValidation('repetitions', element.streamRepetitions, element);
                    onDataChange(
                      element.streamRepetitions,
                      i,
                      configMapping.CBS_REPETITIONS,
                      element
                    )
                  "
                  [matTooltip]="checkValidation('repetitions', element.streamRepetitions)?.message"
                />
              </div>
              <div
                class="expand-fields-alignment"
                *ngIf="showFormField(configMapping.CBS_LINE_RATE)"
              >
                <div class="label">
                  Access rate
                  <i
                    class="material-icons help-icon cbs-fields-icon"
                    matTooltip="Set the CBS field to anything other than 0 to turn on the Committed Burst Size test. Refer to the user manual for more information about the CBS test."
                    >help_outline</i
                  >
                </div>
                <mat-select
                  class="option-list width-70"
                  #txInterfaceInput="ngModel"
                  [(ngModel)]="element.streamAccessRate"
                  (ngModelChange)="calculateMaxLoad(element)"
                  name="streamAccessRate"
                  [disabled]="element.streamCbs <= 0"
                  (selectionChange)="
                    onDataChange(element.streamAccessRate, i, configMapping.CBS_LINE_RATE, element)
                  "
                >
                  <mat-option *ngFor="let accessRate of accessRateTypes" [value]="accessRate.value">
                    {{ accessRate.name }}</mat-option
                  >
                </mat-select>
              </div>
            </div>
            <div
              class="expand-fields-alignment"
              *ngIf="showFormField(configMapping.OVER_HEAD_BYTES)"
            >
              <div class="label">
                Overhead bytes
                <i
                  class="material-icons help-icon"
                  matTooltip="Adds a fixed number of bytes into the throughput calculations to derive a Network Throughput Rate."
                  >help_outline</i
                >
              </div>
              <input
                matInput
                autocomplete="off"
                type="number"
                name="streamOverheadBytes"
                class="width-50"
                [(ngModel)]="element.streamOverheadBytes"
                [ngClass]="{
                  'error-msg': checkValidation('overhead', element.streamOverheadBytes)?.isValid
                }"
                (ngModelChange)="
                  checkValidation('overhead', element.streamOverheadBytes, element);
                  onDataChange(
                    element.streamOverheadBytes,
                    i,
                    configMapping.OVER_HEAD_BYTES,
                    element
                  )
                "
                [matTooltip]="checkValidation('overhead', element.streamOverheadBytes)?.message"
              />
            </div>
            <div class="expand-fields-alignment" *ngIf="showFormField(configMapping.ERROR_ON_OSS)">
              <div class="label">
                Error on OOS
                <i
                  class="material-icons help-icon"
                  matTooltip="Out of sequence frames detected will cause the test to fail."
                  >help_outline</i
                >
              </div>
              <mat-select
                class="option-list width-70"
                #txInterfaceInput="ngModel"
                [(ngModel)]="element.streamOSS"
                name="streamOSS"
                (selectionChange)="
                  onDataChange(element.streamOSS, i, configMapping.ERROR_ON_OSS, element)
                "
              >
                <mat-option *ngFor="let oss of errorOnOssTypes" [value]="oss.value">
                  {{ oss.name }}</mat-option
                >
              </mat-select>
            </div>
            <div class="expand-fields-alignment" *ngIf="showFormField(configMapping.PAYLOAD_TYPE)">
              <div class="label">
                Payload type
                <i class="material-icons help-icon" matTooltip="Choose how packets will be filled"
                  >help_outline</i
                >
              </div>
              <mat-select
                class="option-list width-70"
                #txInterfaceInput="ngModel"
                [(ngModel)]="element.streamPayload"
                name="streamPayload"
                (selectionChange)="
                  onDataChange(element.streamPayload, i, configMapping.PAYLOAD_TYPE, element)
                "
                [ngClass]="{
                  'input-disabled': isMtsAgent
                }"
                [disabled]="isMtsAgent"
              >
                <mat-option *ngFor="let payload of payloadTypes" [value]="payload.value">
                  {{ payload.name }}</mat-option
                >
                <mat-option
                  *ngIf="!agentType.includes('vTA') && !agentType.includes('vSPA')"
                  [value]="48"
                  >512</mat-option
                >
              </mat-select>
            </div>
            <div class="expand-fields-alignment" *ngIf="ipV6Type">
              <div class="label">
                Flow label
                <i
                  class="material-icons help-icon"
                  matTooltip="Flow label is used by a source to label the packets belonging to the same flow in order to request special handling by intermediate IPv6 routers, such as non-default quality of service or real-time service. "
                  >help_outline</i
                >
              </div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="streamFlowLabel"
                class="width-50"
                [(ngModel)]="element.streamFlowLabel"
                [ngClass]="{
                  'error-msg': checkValidation('flowlabel', element.streamFlowLabel)?.isValid
                }"
                (ngModelChange)="
                  checkValidation('flowlabel', element.streamFlowLabel, element);
                  onDataChange(element.streamFlowLabel, i, configMapping.FLOW_LABEL, element)
                "
                [matTooltip]="checkValidation('flowlabel', element.streamFlowLabel)?.message"
                maxlength="5"
              />
            </div>
            <div class="expand-fields-alignment" *ngIf="ipV6Type">
              <div class="label">Traffic Class</div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="streamTrafficClass"
                class="width-50"
                [(ngModel)]="element.streamTrafficClass"
                [ngClass]="{
                  'error-msg': checkValidation('trafficclass', element.streamTrafficClass)?.isValid
                }"
                (ngModelChange)="
                  checkValidation('trafficclass', element.streamTrafficClass, element);
                  onDataChange(element.streamTrafficClass, i, configMapping.TRAFFIC_CLASS, element)
                "
                [matTooltip]="checkValidation('trafficclass', element.streamTrafficClass)?.message"
                maxlength="2"
              />
            </div>
            <div
              class="expand-fields-alignment"
              *ngIf="showFormField(configMapping.TTL) || showFormField(configMapping.HOP_LIMIT)"
            >
              <div class="label">
                TTL/Hop Limit
                <i
                  class="material-icons help-icon"
                  matTooltip="Time to live, or hop limit, is a mechanism which limits the lifetime of data in the network. The higher the number, the more routers the packet can traverse before timing out.
                "
                  >help_outline</i
                >
              </div>
              <input
                matInput
                autocomplete="off"
                type="number"
                name="streamTTL"
                class="width-50"
                [disabled]="isJMEPAgent"
                [(ngModel)]="element.streamTTL"
                [ngClass]="{
                  'error-msg': checkValidation('ttl', element.streamTTL)?.isValid,
                  'input-disabled': isJMEPAgent
                }"
                (ngModelChange)="
                  checkValidation('ttl', element.streamTTL, element);
                  onDataChange(element.streamTTL, i, configMapping.TTL, element);
                  onDataChange(element.streamTTL, i, configMapping.HOP_LIMIT, element)
                "
                [matTooltip]="checkValidation('ttl', element.streamTTL)?.message"
              />
            </div>
            <div class="expand-fields-alignment" *ngIf="isVerifyDSCPSupported()">
              <div class="label">Verify DSCP/TOS</div>
              <mat-select
                class="option-list width-70"
                #verifyDSCPInput="ngModel"
                [(ngModel)]="element.verifyDSCP"
                name="verifyDSCP"
                [disabled]="disableVerifyDSCP"
                (selectionChange)="
                  onDataChange(element.verifyDSCP, i, configMapping.VERIFY_DSCP, element)
                "
              >
                <mat-option *ngFor="let opt of verifyDSCPTypes" [value]="opt.value">
                  {{ opt.name }}</mat-option
                >
              </mat-select>
            </div>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="defaultColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: defaultColumns"
        matRipple
        [ngClass]="!row.strmInUse ? 'element-row-disabled' : 'element-row'"
      ></mat-row>

      <mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        [ngClass]="row.isExpanded === true ? 'expand-row element-row' : 'element-row'"
        [@detailExpand]="row.isExpanded === true ? 'expanded' : 'collapsed'"
        style="overflow: hidden"
      >
      </mat-row>
    </mat-table>
  </div>
</div>
